import { BillableRegistration } from '../model/billableRegistration';
import utils from '@/shared/utils/adminpulse';

export function InvoiceLine(data) {
  // ReSharper disable MisuseOfOwnerFunctionThis
  this.resource = '';
  this.remark = '';
  this.quantity = null;
  this.unitPrice = null;
  this.discountPercentage = null;
  this.vatRate = null;
  this.vatType = null;
  this.type = 3; //Free

  this.billedQuantity = 0;
  this.billedUnitPrice = 0;
  this.billedVatRate = 0;
  this.billedVatType = 0;
  this.billedDiscountPercentage = 0;
  this.baseAmount = 0;
  this.hasRegistrations = false;

  this.registrations = [];
  if (data) angular.extend(this, data);

  if (
    this.registrations != null &&
    this.registrations.length > 0 &&
    !(this.registrations[0] instanceof BillableRegistration)
  ) {
    angular.forEach(this.registrations, function(item, idx, context) {
      context[idx] = new BillableRegistration(item);
    });
  }

  this.displayTime = function() {
    //TFS 5864
    return this.billedQuantity.toTime();
  };
  this.totalRegistrationHours = function() {
    if (!this.registrations || this.registrations.length === 0) return 0;
    const hours = this.registrations
      .reduce(function(sum, reg, index) {
        return sum + (reg.isBilled() && reg.type === 0 ? reg.billedQuantity() || 0 : 0);
      }, 0.0)
      .round(5);
    return hours.toTime();
  };
  this.totalRegistrationAmount = function() {
    if (!this.registrations || this.registrations.length === 0) return 0;
    return this.registrations
      .reduce(function(sum, reg, index) {
        return sum + (reg.isBilled() ? reg.billedAmount() || 0 : 0);
      }, 0.0)
      .round(2);
  };
  this.subtotal = function() {
    return this.baseAmount;
  };

  this.totalExVat = function() {
    return utils.roundAwayFromZero(this.subtotal() * (1 - (this.billedDiscountPercentage || 0)));
  };

  this.totalVat = function() {
    return this.totalExVat() * this.billedVatRate;
  };

  this.totalInclVat = function() {
    return this.totalExVat() * (1 + this.billedVatRate);
  };

  this.isModified = function() {
    return (
      this.hasRegistrations &&
      (this.quantity != null ||
        this.unitPrice != null ||
        this.discountPercentage != null ||
        this.vatRate != null ||
        this.vatType != null)
    );
  };
  this.isRegQuantityModified = function() {
    if (this.registrations)
      for (var i = 0; i < this.registrations.length; i++)
        if (this.registrations[i].quantity != null && this.registrations[i].source !== 1)
          return true;
    return false;
  };
  this.isRegUnitPriceModified = function() {
    if (this.registrations)
      for (var i = 0; i < this.registrations.length; i++)
        if (this.registrations[i].unitPrice != null && this.registrations[i].source !== 1)
          return true;
    return false;
  };
  this.isRegDiscountModified = function() {
    if (this.registrations)
      for (var i = 0; i < this.registrations.length; i++)
        if (this.registrations[i].discountPercentage != null && this.registrations[i].source !== 1)
          return true;
    return false;
  };
  this.isRegVatRateModified = function() {
    if (this.registrations)
      for (var i = 0; i < this.registrations.length; i++)
        if (
          (this.registrations[i].vatRate != null || this.registrations[i].vatType != null) &&
          this.registrations[i].source !== 1
        )
          return true;
    return false;
  };
  this.isRegModified = function() {
    if (this.registrations)
      for (var i = 0; i < this.registrations.length; i++)
        if (this.registrations[i].isModified() && this.registrations[i].source !== 1) return true;
    return false;
  };
  // this.hasRegistrations = function(onlyRealRegistrations) {
  //   if (!onlyRealRegistrations) return this.registrations && this.registrations.length > 0;
  //   return this.registrations && this.registrations.some(x => x.source !== 1);
  // };
  this.registrationsLoaded = function() {
    if (!this.hasRegistrations) return false;
    return !!this.registrations;
  };

  this.isBilled = function() {
    if (!this.registrations || !this.registrations.length) return true;
    if (this.quantity !== null && this.quantity !== 0) return true;
    for (var i = 0; i < this.registrations.length; i++)
      if (this.registrations[i].isBilled()) return true;
    return false;
  };

  this.undo = function() {
    this.quantity = null;
    this.unitPrice = null;
    this.discountPercentage = null;
    this.vatRate = null;
    this.vatType = null;
  };
  this.update = function(data) {
    if (data) angular.extend(this, data);

    for (var i = 0; i < this.registrations.length; i++)
      if (!(this.registrations[i] instanceof BillableRegistration))
        this.registrations[i] = new BillableRegistration(this.registrations[i]);
  };

  this.addRegistration = function(reg) {
    if (!reg) return;
    if (!(reg instanceof BillableRegistration)) reg = new BillableRegistration(reg);
    this.registrations.push(reg);
  };

  this.deleteRegistration = function(regId) {
    for (var i = 0; i < this.registrations.length; i++)
      if (this.registrations[i].id === regId) {
        this.registrations.splice(i, 1);
        return;
      }
  };
  this.updateRegistration = function(reg) {
    for (var i = 0; i < this.registrations.length; i++) {
      if (this.registrations[i].id === reg.id) {
        this.registrations[i].update(reg);
        return;
      }
    }
  };
}
